// Chrome automatically renders a small clear 'x' button on <input type="search" />
// elements. This replaces the native rendering with a themed mask icon so the
// colour can match our Chakra theme.
// A better long-term solution may be to suppress Chrome's native clear button
// and implement a specialised SearchInput with an explicit InputRightElement.
// This would standardise the appearance across browsers.
export const chromeSearchInputClearStyles = {
  'input[type="search"]::-webkit-search-cancel-button': {
    WebkitAppearance: "none",
    appearance: "none",
    width: "0.875rem",
    height: "0.875rem",
    backgroundColor: "var(--chakra-colors-gray-400)",
    maskImage:
      "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 4l8 8M12 4l-8 8' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\")",
    maskRepeat: "no-repeat",
    maskPosition: "center",
    maskSize: "contain",
    cursor: "pointer",
  },

  'input[type="search"]::-webkit-search-cancel-button:hover': {
    backgroundColor: "var(--chakra-colors-gray-700)",
  },

  'input[type="search"]::-webkit-search-cancel-button:active': {
    backgroundColor: "var(--chakra-colors-gray-700)",
  },
};
